import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
    myStyle?:string
}
    
     function Arrowleft({ color , myStyle }: Props): ReactElement {

    return (
        <svg className={myStyle ? myStyle : ""} width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.99925 12.2797L1.65258 7.93306C1.13924 7.41973 1.13924 6.57973 1.65258 6.06639L5.99925 1.71973" stroke={color ? color : "black"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default Arrowleft;